import Vimeo from "@u-wave/react-vimeo";
import React from "react";
import { Link } from "react-router-dom";
import { innerWidthHandler } from "../utils/helpers";
import { useTranslation, Trans } from "react-i18next";

import Topbar from "../components/topbar/topbar";
import Footer from "../pages/client/appointment/footer";

export default function RegisterMediumVideo() {
  const { t } = useTranslation("mediumRegister");
  return (
    <>
      <Topbar />

      <div className="coming-soon height-unset mb-5 ">
        <Vimeo
          muted={true}
          autoplay={true}
          className="popover-video popover-video-registration"
          width={innerWidthHandler()}
          height={430}
          video={"https://vimeo.com/678206499/ba93cdbfe1"}

        />
        <div className="mt-5">
          <ol className="font-size-18 line-height-24px">
            <li>{t("registrationVideo.watchVideo")} </li>
            <li><Trans i18nKey="registrationVideo.codeOfEthics" ns="mediumRegister" t={t} components={{ anchor: <a target="_blank" href="https://verysoul.com/code-of-ethics/" /> }} />
            </li>
            <li><Trans i18nKey="registrationVideo.operatingPrinciples" ns="mediumRegister" t={t} components={{ anchor: <a target="_blank" href="https://verysoul.com/operating-principle/" /> }} />

            </li>
            <li><Trans i18nKey="registrationVideo.mediumFaqs" ns="mediumRegister" t={t} components={{ anchor: <a target="_blank" href="https://verysoul.com/medium-faqs" /> }} />

            </li>
          </ol>
          <p className="font-size-18 line-height-24px">
            <Trans i18nKey="registrationVideo.stillQuestions" ns="mediumRegister" t={t} components={{ anchor: <a href={process.env.REACT_APP_SUPPORT_URL} target="_blank" /> }} />

          </p>
          <p className="font-size-18 line-height-24px">{t("registrationVideo.afterRegistration")}</p>
        </div>
        <div className="text-center">
          <Link className="coming-soon-btn  skip-pbtn m-3" to={"/login"}>
            {" "}
            {t("registrationVideo.cancel")}
          </Link>

          <Link className="coming-soon-btn m-3" to={"/register-medium"}>
            {" "}
            {t("registrationVideo.continue")}
          </Link>
        </div>
      </div >
      <div className="text-center">
      <Footer />
      </div>
    </>
  );
}
